import ClaimMissingPointsForm from './ClaimMissingPointsForm';

export default ClaimMissingPointsForm;
